// extracted by mini-css-extract-plugin
export default {"resultItem":"O2WJAl5xkLfjeuBwSs05","resultItemHighlighted":"ronVcbwIRQL7troBheFY","resultItemLink":"xA0dxO1DfJxB60NE_j6a"};